import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { Member, TeamTexts } from "@/core/models";

@Injectable({ providedIn: "root" })
export class TeamService {
  constructor(private http: HttpClient) {}

  getMembers() {
    return this.http.get<Member[]>(`api/team/members`).pipe((s) => {
      return s;
    });
  }

  getTexts() {
    return this.http.get<TeamTexts>(`api/team/texts`).pipe((s) => {
      return s;
    });
  }

  uploadPhoto(profileImage: File) {
    const formData = new FormData();
    formData.append("file", profileImage, profileImage.name);

    return this.http
      .post("api/team/uploadphoto", formData, {
        reportProgress: true,
        observe: "events",
      })
      .pipe((s) => {
        return s;
      });
  }

  createMember(member: Member) {
    return this.http.post(`api/team/member`, member).pipe((s) => {
      return s;
    });
  }

  updateMember(member: Member) {
    return this.http
      .post(`api/team/member/${member.subUserId}`, member)
      .pipe((s) => {
        return s;
      });
  }

  removeMember(member: Member) {
    return this.http.post(`api/team/removemember`, member).pipe((s) => {
      return s;
    });
  }

  remindPassword(member: Member) {
    return this.http.post(`api/team/remindpassword`, member).pipe((s) => {
      return s;
    });
  }

  validateMember(member: Member) {
    return this.http.post(`api/team/validatemember`, member).pipe((s) => {
      return s;
    });
  }

  validateLogin(member: Member) {
    return this.http.post(`api/team/validatelogin`, member).pipe((s) => {
      return s;
    });
  }
}
